/**
 * Mobile breakpoint for social activity cards
 * Adjust this value to change when cards switch from desktop to mobile layout
 */
export const MOBILE_BREAKPOINT = '1024px';
